import "./style.scss";
import {
  IADatabaseCommentsDocument,
  IADatabaseCreateCommentDocument,
  IADatabaseDocument,
  IADatabaseSendEmailDocument,
} from "@/src/types/admissionDatabase";
import { useForm } from "react-hook-form";
import { AODSvgExport } from "@/src/svg/admissionOfficeDatabase/AODSvgExport";
import { FC, useState, useRef, useEffect } from "react";
import { admissionDatabaseRequests } from "@/src/api/admissionOfficeDatabaseRequests";
import { admissionDatabaseApi } from "@/src/api/axiosInstance";
import CustomDocumentPreviewModal from "@/src/components/CustomUtils/CustomDocumentPreviewModal/CustomDocumentPreviewModal";
import { useDispatch } from "react-redux";
import { setIsPreloyder } from "@/src/store/slices/Preloyder/PreloyderSlice";

interface IAODBDocumentActions {
  row: IADatabaseDocument;
}

const AODBDocumentActions: FC<IAODBDocumentActions> = ({ row }) => {
  const dispatch = useDispatch();
  // const isDocumentCommented = !!(row.comments?.length && row.comments.length > 0);
  const [isDocumentCommented, setIsDocumentCommented] = useState<boolean>(!!row.comments?.length && row.comments.length > 0);
  const [actualCommentsDoc, setActualCommentsDoc] = useState<
    (IADatabaseCommentsDocument | IADatabaseCreateCommentDocument)[] | [] | undefined
  >(row.comments);
  // const [hoveredAction, setHoveredAction] = useState<string | null>(null);
  const [isModalShow, setModalShow] = useState<string | null>(null);
  const userOffice = localStorage.getItem("userID");

  /* -- comment -- */
  // const [comments, setComments] = useState<string[]>([]);
  const [commentValue, setCommentValue] = useState("");
  /* -- comment -- */
  /* -- send-email -- */
  const formRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    setIsDocumentCommented(actualCommentsDoc && actualCommentsDoc?.length > 0 ? true : false);
  }, [actualCommentsDoc]);

  const handleSubmit = async (data: IADatabaseSendEmailDocument) => {
    const isConfirmed = window.confirm("Are you sure that you what to send form?");
    if (!isConfirmed) return;
    dispatch(setIsPreloyder(true));
    const obj = {
      seria: row.document_seria,
      name: row.whose_doc,
      ...data,
    };
    try {
      const response = await admissionDatabaseRequests.sendEmailCurrentDocument(obj);
      console.log(response);
      dispatch(setIsPreloyder(false));
    } catch (error) {
      console.error("Ошибка при удалении документа:", error);
      dispatch(setIsPreloyder(false));
      alert("An unexpected error occurred - write to the developers");
    }
    setModalShow(null);
  };

  const handleOkClick = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };
  function SendDocumentForm({ onSubmit, formRef }: { onSubmit: (data: any) => void; formRef: React.RefObject<HTMLFormElement | null> }) {
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        sender_email: "default",
        recipient_email: "",
        subject_email: "",
        body_email: "without-text",
      },
    });

    return (
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-body-form-input">
          <label>Select email</label>
          <select
            {...register("sender_email", {
              validate: (value) => value !== "default" || "Please select an email",
            })}
            defaultValue="default"
            style={{ appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
          >
            <option value="default" disabled>
              Select email
            </option>
            <option value="developer@ieu.edu.ua">developer@ieu.edu.ua</option>
            <option value="elearning@ieu.edu.ua">elearning@ieu.edu.ua</option>
          </select>
          {errors.sender_email && <p>Please select an email</p>}
        </div>
        <div className="modal-body-form-input">
          <label>Where to send</label>
          <input
            type="email"
            placeholder="Address"
            {...register("recipient_email", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Please enter a valid email address",
              },
            })}
          />
          {errors.recipient_email && <p>{errors.recipient_email.message}</p>}
        </div>
        <div className="modal-body-form-input">
          <label>Subject email</label>
          <input type="text" placeholder="Subject email" {...register("subject_email", { required: true })} />
          {errors.subject_email && <p>Subject is required</p>}
        </div>
        <div className="modal-body-form-input">
          <label>Cover letter text</label>
          <select
            {...register("body_email", { required: true })}
            style={{ appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
          >
            <option value="without-text">Without text</option>
            <option value="cover-letter">Cover letter text for transcript</option>
          </select>
          {errors.body_email && <p>Select an option</p>}
        </div>
      </form>
    );
  }
  /* -- send-email -- */
  const documentAction = async (type: string) => {
    switch (type) {
      case "prev":
        setModalShow(type);
        break;
      case "comment":
        setModalShow(type);
        break;
      case "send-email":
        setModalShow(type);
        break;
      case "download":
        if (!row.pdf_path) {
          console.error("Нет пути к файлу");
          return;
        }
        const fileUrl = row.pdf_path.startsWith("http") ? row.pdf_path : `${admissionDatabaseApi.defaults.baseURL}${row.pdf_path}`;
        try {
          const response = await fetch(fileUrl);
          if (!response.ok) throw new Error("Ошибка при загрузке файла");

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${row.full_name}_${row.title}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Ошибка при скачивании документа:", error);
        }
        break;

      case "delete":
        const isConfirmed = window.confirm("Are you sure you want to delete this document?");
        if (!isConfirmed) return;

        try {
          const response = await admissionDatabaseRequests.deleteCurrentDocument(Number(row.id), userOffice ? userOffice : "without login");
          console.log(response);
        } catch (error) {
          console.error("Ошибка при удалении документа:", error);
        }
        break;
    }
  };

  const renderPopUp = (type: string) => {
    // const isHovered = hoveredAction === type;
    const isOpen = isModalShow === type;
    switch (type) {
      case "prev":
        const fileUrl = row.pdf_path
          ? row.pdf_path.startsWith("http")
            ? row.pdf_path
            : `${admissionDatabaseApi.defaults.baseURL}${row.pdf_path}`
          : null;
        return (
          <>
            {/* {isHovered ? <AODSvgExport.AODPrevDocHoverSvg /> : <AODSvgExport.AODPrevDocSvg />} */}
            <AODSvgExport.AODPrevDocSvg />
            <CustomDocumentPreviewModal
              isOpen={isOpen && Boolean(fileUrl)}
              documentUrl={fileUrl}
              onClose={() => setModalShow(null)}
              // onApprove={() => console.log("Document approved:", row.id)}
              // onReject={() => console.log("Document rejected:", row.id)}
              title={`${row.full_name} — ${row.title}`}
            />
          </>
        );

      case "comment":
        // const CommentSvg = isDocumentCommented ? (
        //   isHovered ? (
        //     <AODSvgExport.AODHasCommentDocHoverSvg />
        //   ) : (
        //     <AODSvgExport.AODHasCommentDocSvg />
        //   )
        // ) : isHovered ? (
        //   <AODSvgExport.AODCommentDocHoverSvg />
        // ) : (
        //   <AODSvgExport.AODCommentDocSvg />
        // );
        const CommentSvg = isDocumentCommented ? <AODSvgExport.AODHasCommentDocSvg /> : <AODSvgExport.AODCommentDocSvg />;
        const handleEventCommentOk = async () => {
          if (commentValue.trim() !== "") {
            const isConfirmed = window.confirm("Are you sure you want to send this comment?");
            if (!isConfirmed) return;
            const now = new Date();
            const formatted = now.toLocaleString("ru-RU").replace(",", "");
            const data = {
              document_id: row.id,
              date: formatted,
              name: row.whose_doc,
              text: commentValue,
            };
            try {
              const response = await admissionDatabaseRequests.createCommentCurrentDocument(data);
              console.log(response);
            } catch (error) {
              console.error("Ошибка при удалении документа:", error);
            }
            setActualCommentsDoc((prev) => [...(prev || []), data]);
            setCommentValue("");
            setModalShow(null);
          } else {
            setModalShow(null);
          }
        };
        const handleEventCommentDelete = async (id: number) => {
          const isConfirmed = window.confirm("Are you sure you want to delete this comment?");
          if (!isConfirmed) return;
          const data = { comment_id: id };
          try {
            const response = await admissionDatabaseRequests.deleteCommentCurrentDocument(data);
            console.log(response);
          } catch (error) {
            console.error("Ошибка при удалении документа:", error);
          }
          setActualCommentsDoc((prev) => (prev ? prev.filter((comment) => "id" in comment && comment.id !== id) : []));
          setModalShow(null);
        };
        const handleEventClearAllComments = async (id: number) => {
          const isConfirmed = window.confirm("Are you sure you want to delete all comments?");
          if (!isConfirmed) return;
          const data = { document_id: id };
          try {
            const response = await admissionDatabaseRequests.deleteAllCommentsCurrentDocument(data);
            console.log(response);
            if (response !== null) {
              setActualCommentsDoc([]);
              setModalShow(null);
            }
          } catch (error) {
            console.error("Ошибка при удалении документа:", error);
          }
        };
        return (
          <>
            {CommentSvg}
            {isOpen && (
              <div className="document-actions-modal comment-modal" onClick={(e) => e.stopPropagation()}>
                {/* <div className="modal-close-btn" onClick={closeModal}></div> */}
                <div className="modal-body">
                  <div className="modal-body-header">
                    <p className="modal-body-header-title">Comments</p>
                    <p className="modal-body-header-clear" onClick={() => row.id && handleEventClearAllComments(row.id)}>
                      Clear all comments
                    </p>
                  </div>
                  <div className="modal-body-comments">
                    {actualCommentsDoc && actualCommentsDoc.length
                      ? actualCommentsDoc.map((comment, index) => (
                          <div className="modal-body-comments-comment" key={index}>
                            <div className="modal-body-comments-comment-text">
                              <p>
                                <span>{comment.date}</span>
                              </p>
                              <p>
                                <span>{comment.name}</span> {comment.text}
                              </p>
                            </div>
                            {"id" in comment && (
                              <div className="modal-body-comments-comment-delete" onClick={() => handleEventCommentDelete(comment.id!)}>
                                <AODSvgExport.AODDeleteDocSvg />
                              </div>
                            )}
                          </div>
                        ))
                      : ""}
                  </div>
                  <div className="modal-body-input">
                    <input type="text" placeholder="Comment..." onChange={(e) => setCommentValue(e.target.value)} />
                  </div>
                  <div className="modal-body-buttons">
                    <div className="modal-body-buttons-ok" onClick={handleEventCommentOk}>
                      Ok
                    </div>
                    <div className="modal-body-buttons-cancel" onClick={() => setModalShow(null)}>
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "send-email":
        return (
          <>
            {/* {isHovered ? <AODSvgExport.AODSendEmailHoverSvg /> : <AODSvgExport.AODSendEmailSvg />} */}
            <AODSvgExport.AODSendEmailSvg />
            {isOpen && (
              <div className="document-actions-modal email-modal" onClick={(e) => e.stopPropagation()}>
                {/* <div className="modal-close-btn" onClick={closeModal}></div> */}
                <div className="modal-body">
                  <div className="modal-body-header">
                    <p className="modal-body-header-title">Sending a document</p>
                  </div>
                  <div className="modal-body-form">
                    <SendDocumentForm onSubmit={handleSubmit} formRef={formRef} />
                  </div>
                  <div className="modal-body-buttons">
                    <div className="modal-body-buttons-ok" onClick={handleOkClick}>
                      Ok
                    </div>
                    <div className="modal-body-buttons-cancel" onClick={() => setModalShow(null)}>
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "download":
        // return isHovered ? <AODSvgExport.AODDownloadDocHoverSvg /> : <AODSvgExport.AODDownloadDocSvg />;
        return <AODSvgExport.AODDownloadDocSvg />;

      case "delete":
        // return isHovered ? <AODSvgExport.AODDeleteDocHoverSvg /> : <AODSvgExport.AODDeleteDocSvg />;
        return <AODSvgExport.AODDeleteDocSvg />;
      default:
        return null;
    }
  };

  const actions = ["prev", "comment", "download", "send-email", "delete"];

  return (
    <div className="document-actions">
      {actions.map((action) => (
        <div
          key={action}
          className={`document-actions-item ${action}`}
          onClick={() => documentAction(action)}
          // onMouseEnter={() => setHoveredAction(action)}
          // onMouseLeave={() => setHoveredAction(null)}
        >
          {renderPopUp(action)}
        </div>
      ))}
    </div>
  );
};

export default AODBDocumentActions;
